export default (config) => {
  config.apiServerUrl = (config.ssl ? 'https://' : 'http://') + config.apiServer
  config.redirectToHome = config.websiteUrl
  config.files.staticServerUrl = (config.ssl ? 'https://' : 'http://') + config.files.staticServer
  config.files.thumbServerUrl = (config.ssl ? 'https://' : 'http://') + config.files.thumbServer
  return config
}
